import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, ListItem, MenuItem, Paper, TextField, Typography, useMediaQuery, useTheme, Card, CardContent, Grid } from "@mui/material"
import { TableContainer, TableBody, Table, TableHead, TableRow, TableCell } from "@mui/material"
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Restaurant, MenuBook, Edit, Delete, Close as CloseIcon, Inventory } from "@mui/icons-material";
import { Container } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Collapse from '@mui/material/Collapse';
import { AddMenuForm } from "../../Forms/AddMenuform";
import { WarningDialog } from "../../modal/WarningDialog";

import { addMenu, addMenuBulk, deleteCategory, deleteItem, editCatgCall, editItemCall, getlistCatgory, getlistMenu } from "../../hooks/apiHandler";
import { useAuth } from "../../hooks/useAuth";


// --- NEW UTILITY FUNCTION TO RESTRUCTURE FLAT DATA (OPTIMIZED) ---
const restructureMenuData = (flatData, categoryList) => {
  if (!Array.isArray(flatData)) {
    return [];
  }

  const categoryMap = new Map();
  const categoriesMap = new Map();

  // 1. Initialize categoriesMap with ALL categories (ensuring empty ones are listed)
  categoryList.forEach(cat => {
    const categoryId = cat._id;
    const categoryName = cat.catgory || cat.name;

    categoriesMap.set(categoryId, {
      _id: categoryId,
      catgory: categoryName,
      items: [] // Initialize with an empty items array
    });
    // Also build a simple lookup map for item processing
    categoryMap.set(categoryId, categoryName);
  });

  // 2. Distribute flat menu items into the initialized map
  flatData.forEach(item => {
    const categoryId = item.categoryID || 'uncategorized';

    // If the category exists in the map (which it should now), push the item.
    if (categoriesMap.has(categoryId)) {
      categoriesMap.get(categoryId).items.push(item);
    } else {
      // Handle items whose categoryID might be invalid or missing in the category list
      const defaultId = 'uncategorized';
      if (!categoriesMap.has(defaultId)) {
        categoriesMap.set(defaultId, {
          _id: defaultId,
          catgory: 'Uncategorized',
          items: []
        });
      }
      categoriesMap.get(defaultId).items.push(item);
    }
  });

  // 3. Return the array of all categories (both populated and empty)
  return Array.from(categoriesMap.values());
};
// --- END NEW UTILITY FUNCTION ---



export const MenuPage = () => {


  const { Logout } = useAuth();
  var storeID = useRef(JSON.parse(window.localStorage.getItem('ds')));
  const [listMenu, setMenuList] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const [categoryList, setCategoryList] = useState([]); // State to hold full category list
  var [displayList, setDisplayList] = useState([]);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [showModal, setshowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState({
    popupModel: false,
    catID: '',
    editName: ''
  });
  const [editItem, setEditItem] = useState();
  const [isDialogOpen, setDialogOpen] = useState({ model: false, id: null });


  useEffect(() => {
    // start Loading Icon or Bar.
    async function calldeviceList() {
      var response = await getlistMenu({ storeID: storeID.current }, Logout);
      const listMenu = await response.data;
      if (listMenu) {
        console.log(listMenu);
        setMenuList(listMenu)
      } else {

      };
      var catgResp = await getlistCatgory({ storeID: storeID.current }, Logout);
      const catgList = await catgResp;
      if (catgList) {
        setCategoryList(catgResp.data);
      }
    }

    calldeviceList()
    return () => {
      // this is same as component unmount of leaving the page..
    }
  }, [Logout]);


  useEffect(() => {
    const structuredData = restructureMenuData(listMenu, categoryList);
    setDisplayList(structuredData);
  }, [categoryList, listMenu]);

  const [openIndex, setOpenIndex] = useState(null);
  const handleDropDown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const handleRemoveItem = async (productID) => {
    console.log(productID);
    var response = await deleteItem({ storeID: storeID.current, itemID: productID }, Logout);
    // After deletion, re-fetch and restructure
    setMenuList(response.data.items);
    setCategoryList(response.data.categories);

  }
  const handleRemoveCatg = async (catgoryID) => {
    console.log(catgoryID);
    setDialogOpen({ model: true, id: catgoryID });
  }
  const handleConfirm = async () => {
    console.log("Confirmed action");
    var response = await deleteCategory({ storeID: storeID.current, catgID: isDialogOpen.id }, Logout);
    // After deletion, re-fetch and restructure
    setMenuList(response.data.items);
    setCategoryList(response.data.categories);

    setDialogOpen({ model: false, id: null });
  };

  const handleEditItem = async (productID, currentCatgory) => {
    console.log(productID, currentCatgory);
    // currentCatgory is the Name of the category, stored as currentCatgory in itemInfo for form usage
    setEditItem({ ...productID, currentCatgory });
    setshowModal(true);
  }
  const handleEditCatg = async (productID, name) => {
    console.log(productID);
    console.log(name);
    setShowEditModal({
      popupModel: true,
      catID: productID,
      editName: name
    });
  }

  const handleModelClose = () => {
    setshowModal((prev) => !prev);
    setEditItem();
  };

  // dropdown Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl); // Derived state for open status

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Csv to Json method 


  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];

    if (!file || !(file instanceof Blob)) {
      console.error('Invalid file:', file);
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const text = event.target.result;
      const json = csvToJson(text);
      setJsonData(json);
    };

    reader.readAsText(file);
  };

  const csvToJson = (csv) => {
    const [headerLine, ...lines] = csv.trim().split('\n');
    const headers = headerLine.split(',').map(h => h.trim());

    return lines.map((line) => {
      const values = line.split(',').map(v => v.trim());
      const obj = {};
      headers.forEach((header, i) => {
        obj[header] = values[i] ?? '';
      });
      return obj;
    });
  };

  // eslint-disable-next-line
  const sendToApi = async (csvRows) => {
    try {
      // Map CSV headers to match API format
      const menuItems = csvRows.map(row => ({
        category: row.category || row.Category,  // case-insensitive mapping
        item: row.item || row.Item,
        price: parseFloat(row.price || row.Price) || 0,
        description: row.description || row.Description || "",
        available: row.available !== undefined ? row.available === "true" || row.available === true : true,
        inStore: row.inStore !== undefined ? row.inStore === "true" || row.inStore === true : true,
        online: row.online !== undefined ? row.online === "true" || row.online === true : true,
        restaurantPatner: row.restaurantPatner !== undefined ? row.restaurantPatner === "true" || row.restaurantPatner === true : false,
      }));

      const payload = {
        storeID: storeID.current,
        menuItems: menuItems
      };

      const response = await addMenuBulk(payload, Logout);

      if (response.code === 0) {
        console.log("Bulk upload successful:", response.data);
        // FIX: Restructure data after bulk upload
        const structuredData = restructureMenuData(response.data, categoryList);
        setMenuList(structuredData);
        setJsonData([]);
      } else {
        console.error("Bulk upload failed:", response);
      }
    } catch (error) {
      console.error(" Error in sendToApi:", error);
    }
  };



  return (
    <Container>
      <Box sx={{ display: "flex", justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <Box>
          <Chip sx={{ m: '10px' }} label={`Total Category: ${(categoryList || []).length}`} onClick={() => { }} />
          <Chip sx={{ m: '10px' }} label={`Number of Items: ${listMenu.length}`} variant="outlined" onClick={() => { }} />
        </Box>
        <Box>
          <Button sx={{ m: '10px' }} variant="outlined" onClick={() => {
            setshowModal((prev) => !prev);
          }}>+Add Menu</Button>
          <IconButton
            aria-label="more"
            aria-controls={open ? "csv-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="csv-menu" anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem>
              <label htmlFor="upload-csv" style={{ width: "100%", cursor: "pointer" }}>
                <ListItemText primary="Upload CSV" />
              </label>
              <input
                id="upload-csv"
                type="file"
                accept=".csv"
                hidden
                onChange={handleFileUpload}
              />
            </MenuItem>
            <MenuItem component="a" href="/menu_items.csv" download onClick={handleClose}>
              <ListItemText primary="Download Menu CSV" />
            </MenuItem>
          </Menu>
        </Box>
      </Box>


      {
        jsonData.length === 0 ? (
          <></>
        ) : (

          <>
            {isMobile ? (
              /* MOBILE VIEW */
              <Box sx={{ mt: 2 }}>
                {jsonData.map((row, rowIndex) => (
                  <Card key={rowIndex} sx={{ mb: 2, boxShadow: 3 }}>
                    <CardContent>
                      {Object.entries(row).map(([key, val], colIndex) => (
                        <Box
                          key={colIndex}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mb: 1,
                            borderBottom: '1px solid #eee',
                            pb: 0.5
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
                            {key}
                          </Typography>
                          <Typography variant="body2" sx={{ textAlign: 'right' }}>
                            {val}
                          </Typography>
                        </Box>
                      ))}
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              /* DESKTOP VIEW*/
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {Object.keys(jsonData[0]).map((key, index) => (
                        <TableCell key={index} sx={{ fontWeight: "bold" }}>
                          {key}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {jsonData.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {Object.values(row).map((val, colIndex) => (
                          <TableCell key={colIndex}>{val}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}


            <Box
              sx={{
                display: "flex",

                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "flex-end",
                gap: 2,
                mt: 2
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setJsonData([])}
                fullWidth={isMobile}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => sendToApi(jsonData)}
                fullWidth={isMobile}
              >
                Save
              </Button>
            </Box>
          </>
        )
      }


      <Box sx={{ p: 2 }}></Box>


      <List>
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
          {displayList.length > 0 ? (
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {displayList.map((item, pindex) => (
                <React.Fragment key={`cat-${pindex}`}>

                  <ListItem
                    sx={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: 2,
                      mb: 1,
                      transition: "0.3s",
                      "&:hover": { backgroundColor: "#e0e0e0" },
                    }}
                  >
                    <ListItemButton onClick={() => handleDropDown(pindex)}>
                      <ListItemIcon>
                        <MenuBook sx={{ color: "#3f51b5" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="h6" fontWeight="bold">
                            {item.catgory}
                          </Typography>
                        }
                      />
                      <Chip
                        size="small"
                        label={`Items: ${item.items.length}`}
                        sx={{ borderColor: "#3f51b5", color: "#3f51b5" }}
                        variant="outlined"
                      />
                      {openIndex === pindex ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                  </ListItem>

                  {/* 📌 Collapsible Section for Items */}
                  <Collapse in={openIndex === pindex} timeout="auto" unmountOnExit>
                    <Box sx={{ pl: 4, pb: 1 }}>
                      {/* 📌 Category Edit & Delete Actions */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#eeeeee",
                          p: 1,
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          Edit Category: {item.catgory}
                        </Typography>
                        <Box>
                          <IconButton color="warning" size="small"
                            onClick={() => handleEditCatg(item._id, item.catgory)}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton color="error" size="small"
                            onClick={() => handleRemoveCatg(item._id)}
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      {/* 📌 Nested Items List */}
                      <List disablePadding>
                        {item.items.map((nestedItem, index) => (
                          <ListItem
                            key={`item-${pindex}-${nestedItem._id}`} // Use nestedItem._id for stable key
                            sx={{
                              pl: 2,
                              borderRadius: 1,
                              mb: 1,
                              transition: "0.3s",
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            <ListItemIcon>
                              <Restaurant sx={{ color: "#43a047" }} />

                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="subtitle1">
                                  {nestedItem.item} {nestedItem.stockmanaged ? (<Inventory sx={{ fontSize: 15 }} />) : ''}
                                </Typography>
                              }
                              secondary={`Price: $${nestedItem.price}`}
                            />
                            {/* 📌 Item Actions */}
                            <Box>
                              <IconButton color="warning" size="small"
                                onClick={() => handleEditItem(nestedItem, item._id)}
                              >
                                <Edit />
                              </IconButton>
                              <IconButton color="error" size="small"
                                onClick={() => handleRemoveItem(nestedItem._id)}
                              >
                                <Delete />
                              </IconButton>
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </Collapse>

                </React.Fragment>
              ))}
            </List>
          ) : (
            <Typography variant="body1" textAlign="center" color="textSecondary">
              No Data Found For Display.
            </Typography>
          )}
        </Paper>
      </List>

      <Dialog
        open={showModal}
        onClose={handleModelClose}
        maxWidth="md"
        fullWidth
        // Ensure the dialog body itself can scroll if the content is tall
        scroll="paper"
        sx={{ '& .MuiDialog-paper': { minHeight: 400, maxHeight: '90vh' } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {editItem ? 'Edit Menu Item' : 'Add New Menu Item'}
          <IconButton
            onClick={handleModelClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>

          <AddMenuForm
            catgList={categoryList}
            menuList={listMenu}
            itemInfo={editItem || {}} // Pass empty object if adding, or item data if editing
            onsave={async (formData, currentCatgory) => {
              const isEditing = Boolean(editItem);
              const apiCall = isEditing ? editItemCall : addMenu;
              let newData = { ...formData };

              try {
                const response = await apiCall(newData, Logout);
                if (response.code === 0) {
                  // FIX: Restructure data after successful save
                  setMenuList(response.data.items);
                  setCategoryList(response.data.categories);
                } else {
                  console.log('Failed to add menu item. Please try again.');
                }
              } catch (error) {
                console.error('Error occurred while adding menu:', error);
              }

              handleModelClose();
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleModelClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showEditModal.popupModel} onClose={() => setShowEditModal({
        popupModel: false,
        catID: '',
        editName: ''
      })}>
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
            <TextField
              variant="filled"
              id="storename"
              value={showEditModal.editName}
              type="text"
              placeholder="Enter category name"
              required
              size="small"
              onChange={(e) => { setShowEditModal({ ...showEditModal, editName: e.target.value }) }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEditModal({
            popupModel: false,
            catID: '',
            editName: ''
          })}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                var response = await editCatgCall({ storeID: storeID.current, id: showEditModal.catID, editName: showEditModal.editName }, Logout);
                if (await response.code === 0) {
                  // FIX: Restructure data after successful category edit
                  setMenuList(response.data.items);
                  setCategoryList(response.data.categories);
                } else {
                  console.log(response);
                }
                setShowEditModal({
                  popupModel: false,
                  catID: '',
                  editName: ''
                })
              } catch (error) {
                console.error("Error updating category:", error);
              }
            }}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <WarningDialog
        isOpen={isDialogOpen.model}
        onClose={() => setDialogOpen({ model: false, id: null })}
        onConfirm={handleConfirm}
        title="Warning!"
        message={<span>Are you sure you want to proceed? <br /><br /> All Items in the Catgory Will be Remove...</span>}
      />


    </Container >
  );
};